// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "header-28hMX";
var _3 = "header_zeroPrice-3OfMN";
var _4 = "stepIndex-2oQpF";
var _5 = "stepIndex__label-1tEJ2";
var _6 = "price-U5RWO";
var _7 = "price__wrapper-2jyVm";
var _8 = "price_title-eNk7H";
var _9 = "expand-2MOha";
var _a = "expand_open-3TWET";
export { _1 as "__esModule", _2 as "header", _3 as "header_zeroPrice", _4 as "stepIndex", _5 as "stepIndex__label", _6 as "price", _7 as "price__wrapper", _8 as "price_title", _9 as "expand", _a as "expand_open" }
export default { "__esModule": _1, "header": _2, "header_zeroPrice": _3, "stepIndex": _4, "stepIndex__label": _5, "price": _6, "price__wrapper": _7, "price_title": _8, "expand": _9, "expand_open": _a }
